module.exports = __webpack_public_path__ + "static/media/orders-selected.d7d677fe.svg";